import ToastsContainer from "../ToastsContainer";

export default function ToastHandler(): React.JSX.Element {
	return <ToastsContainer />;
}
